require('./shop-all-ts.scss');
require('../mui/standard-addrselect/standard-addrselect.scss');

const React = require('react');
const config = require('../../config');
const shallowCompare = require('react-addons-shallow-compare');
const IScroll = require('@portal/iscroll/build/iscroll-probe');
const classnames = require('classnames');
const helper = require('../../helper/dish-helper.js');
const shopLogoDefault = require('../../asset/images/logo_default.svg');
const noDataImageUrl = require('../../asset/images/shoplist-no-data.svg');
const noDataImageUrlSpe = require('../../asset/images/shoplist-no-data-spe.svg');
const StandardAddrselectSearchbox = require('../mui/standard-addrselect/standard-addrselect-searchbox');
const StandardAddrselectSearchboxYCS = require('../mui/standard-addrselect/standard-addrselect-searchbox-ycs');
import pageHelper from '../../helper/page-helper';
import HttpsProtocolImage from '../common/https-protocol-image';
// eslint-disable-next-line
import { getPoint } from '../../helper/map-TARGET_AREA';

import FormattedMessage from '@/intl/formatted-message';
import { formatMessage } from '../../intl/helper';
import shopText from '../../intl/messages/shop';
import muiText from '../../intl/messages/mui';
import activateText from '../../intl/messages/activate';

const ShopAllTS = React.createClass({
  displayName: 'shopAllTS',
  propTypes: {
    // props
    allNearShopList: React.PropTypes.object.isRequired,
    allShopList: React.PropTypes.object.isRequired,
    getQueueInfo: React.PropTypes.func,
    setLoadMsg: React.PropTypes.func,
    getAllShopList: React.PropTypes.func,
    getNearShopList: React.PropTypes.func,
    clearAllShopList: React.PropTypes.func,
    clearNearShopList: React.PropTypes.func,
    curPosition: React.PropTypes.object.isRequired,
    addressOk: React.PropTypes.any.isRequired,
    cityList: React.PropTypes.array.isRequired,
    yunChengSchoolFlag: React.PropTypes.bool,
    getYCSAllShopList: React.PropTypes.func,
    setErrorMsg: React.PropTypes.func,
  },

  getInitialState() {
    return {
      showLoad: false,
      city: formatMessage(muiText.muinearbyStore),
      showCityChangeList: false,
      keyWord: '',
      dinningRoomIndex: 0,
      chosenPosition: {},
      selectType: 'near',
      dinningName: '一食堂',
      ycsSelectType: false,
      ycsGreyBg: false,
      forceCityPopupVisible: false,
    };
  },

  componentDidMount() {
    this.pageNumAll = 1; // 当前页面
    this.pageNumNear = 1; // 当前页面
    const iScroll = (this.iScroll = new IScroll('.shop-all-ts', {
      click: true,
      tap: true,
      probeType: 3,
    }));

    iScroll.on('scrollStart', () => {
      this._className = '';
    });

    iScroll.on('scroll', () => {
      const distance = Math.abs(iScroll.y) - Math.abs(iScroll.maxScrollY);
      if (distance >= 80) {
        this._className = 'flip';
      }
    });

    iScroll.on('scrollEnd', () => {
      if (this._className === 'flip') {
        this.addItems();
      }
    });
  },

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  },

  componentDidUpdate(prevProps, prevState) {
    this.iScroll.refresh();
  },

  getNoDataTip(tipData) {
    return (
      <div className="of">
        <img alt="" src={tipData.img} className="noDataImage" />
        <div className="locate-fail">
          {tipData.word}
          {tipData.word2 ? <p>{tipData.word2}</p> : ''}
          {tipData.noPosition && (
            <a
              onTouchTap={() => {
                location.href = location.href;
              }}
              className="locate-reset"
              href="#"
            >
              <FormattedMessage {...shopText.shopreGet} />
            </a>
          )}
        </div>
      </div>
    );
  },

  handleCityPopupVisible(visible) {
    this.setState({ forceCityPopupVisible: visible });
  },

  handleViewShopsInTheCity() {
    const { addressOk, curPosition = {}, cityList } = this.props;

    // 定位失败弹出城市选择浮层
    if (!addressOk) {
      this.setState({ forceCityPopupVisible: true });
      return;
    }

    if (!cityList) {
      return;
    }

    const cityName = curPosition.city;
    const city = cityList.filter(item => cityName && cityName.indexOf(item.name) === 0)[0];
    if (!city) {
      this.setState({ forceCityPopupVisible: true });
      return;
    }
    this.cityChange({ name: city.name, value: city.id });
    return;
  },

  renderViewShopInCityLink() {
    return (
      <a onTouchTap={this.handleViewShopsInTheCity} className="shop-all-ts__view-shop-incity o-bg-grey">
        <FormattedMessage {...shopText.shopshowAllShop} />
      </a>
    );
  },

  getNearShopList() {
    const { addressOk, allNearShopList = {} } = this.props;
    const { cList } = allNearShopList;

    const tipNoAddressData = {
      word: formatMessage(shopText.shopcannotGetAddress),
      img: noDataImageUrl,
      noPosition: true,
    };
    const tipData = {
      word: formatMessage(shopText.shopnoShopIn5km),
      word2: formatMessage(shopText.shopunSetLocation),
      img: noDataImageUrlSpe,
    };

    if (!addressOk) {
      return (
        <div>
          {this.getNoDataTip(tipNoAddressData)}
          {this.renderViewShopInCityLink()}
        </div>
      );
    }

    if (cList && cList.length > 0) {
      return this.getShopOptions(cList);
    }

    if (cList && cList.length === 0) {
      return (
        <div>
          {this.getNoDataTip(tipData)}
          {this.renderViewShopInCityLink()}
        </div>
      );
    }
    return false;
  },

  getAllShopList() {
    const { allShopList = {} } = this.props;
    const tipData = {
      word: formatMessage(shopText.shopnoShopInfo),
      img: noDataImageUrlSpe,
    };
    const { cList } = allShopList;

    if (cList && cList.length > 0) {
      return this.getShopOptions(cList);
    }

    if (cList && cList.length === 0) {
      return this.getNoDataTip(tipData);
    }

    return false;
  },

  getShopOptions(data = []) {
    return (
      <div className="o-list o-border--bottom">
        {data.map((item = {}, index) => {
          const imgUrl = item.commercialLogo || shopLogoDefault;
          const openStatus = item.openStatus === true ? formatMessage(shopText.shopOpen) : formatMessage(shopText.shopClosed);
          return (
            <div className="o-list__item c-shop-entry" key={item.commercialID + '' + index} onTouchTap={() => this.jumpToShopIndex(item.commercialID)}>
              <div className="o-media">
                <HttpsProtocolImage src={imgUrl} className="o-media__img c-shop-entry__img" alt="默认图片" loadErrorImageSrc={shopLogoDefault} />
                <div className="o-media__body c-description c-shop-entry__info">
                  <div className="c-description__title">
                    <div className="o-text-ellipsis">{item.commercialName || '匿名门店'}</div>
                  </div>
                  <div className="c-description__body c-shop-entry__meta">
                    <p className="c-shop-entry__name">
                      <span
                        className={classnames('c-shop-entry__status o-fz--11', {
                          'c-shop-entry__status--off': !item.openStatus,
                          'c-shop-entry__status--on': item.openStatus,
                        })}
                      >
                        {openStatus}
                      </span>
                      <span className="o-fz--13">{item.busiName}</span>
                    </p>
                    {this.props.yunChengSchoolFlag ? '' : <span>{this.formatDistance(item.distance)}</span>}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  },

  // YCS 品牌
  getYCSNearShopList() {
    const { allNearShopList = {} } = this.props;
    const { cList } = allNearShopList;
    let content = '';
    const tipData = {
      word: formatMessage(shopText.shopnoStoreInfo),
      img: noDataImageUrlSpe,
    };

    if (cList && cList.length > 0) {
      this.getShopOptions(cList);
    }

    if (cList && cList.length === 0) {
      content = this.getNoDataTip(tipData);
    }

    return content;
  },

  // YCS 品牌
  getYCSAllShopList() {
    const { allShopList = {} } = this.props;
    const { cList } = allShopList;
    const tipData = {
      word: formatMessage(shopText.shopnoStoreInfo),
      img: noDataImageUrlSpe,
    };

    if (cList && cList.length > 0) {
      return this.getShopOptions(cList);
    }

    if (cList && cList.length === 0) {
      return this.getNoDataTip(tipData);
    }
  },

  addItems() {
    const { selectType } = this.state;
    if (selectType === 'all') {
      this.pageNumAll++;
      this.showAllShopList(null, this.pageNumAll);
    } else if (selectType === 'near') {
      this.pageNumNear++;
      this.showNearShopList(null, this.pageNumNear);
    }
  },

  // YCS
  dinningChange(dinningObj = {}) {
    const { getYCSAllShopList } = this.props;
    this.setState({
      dinningName: dinningObj.dinningName,
      dinningRoomIndex: parseInt(dinningObj.value, 10),
      ycsSelectType: true,
      ycsGreyBg: false,
    });

    this.setState(
      {
        selectType: 'all',
        dinningName: dinningObj.dinningName,
        dinningRoomIndex: dinningObj.value,
      },
      () => {
        const pageNum = 1;
        const keyWord = '';
        const dinningRoomIndex = this.state.dinningRoomIndex;
        const listObjParam = { pageNum, keyWord, dinningRoomIndex };

        this.props.clearNearShopList();
        this.props.clearAllShopList();

        getYCSAllShopList(listObjParam);
      },
    );

    if (this.timer) {
      clearTimeout(this.timer);
    }
  },

  cityChange(cityObj = {}) {
    const { setLoadMsg, setErrorMsg, clearAllShopList } = this.props;

    setLoadMsg({ status: true, word: formatMessage(shopText.shopChanging) });

    if (cityObj.value === 'near') {
      this.setState({ selectType: 'near', city: `${cityObj.name}` });
    } else {
      this.setState({ selectType: 'all', city: `${cityObj.name}` });
    }

    if (this.timer) {
      clearTimeout(this.timer);
    }

    // 根据城市获取坐标
    if (cityObj.value === 'near') {
      this.props.clearNearShopList();
      this.timer = setTimeout(() => {
        this.showNearShopList(null, 1);
        this.pageNumNear = 1;
      }, 500);

      return;
    }

    clearAllShopList();
    // 重庆城区 地图定位不出经纬度，改成重庆市-产品杨森提的解决方案
    if (cityObj && cityObj.name === '重庆城区') {
      cityObj.name = '重庆';
    }
    getPoint(cityObj.name, cityObj.name)
      .then(point => {
        const chosenPosition = {
          city: `${cityObj.name}`,
          cityId: cityObj.value,
          longitude: '',
          latitude: '',
          isGetLoc: true,
        };
        Object.assign(chosenPosition, { longitude: point.lng, latitude: point.lat });
        this.setState(
          {
            chosenPosition,
            keyWord: '',
          },
          () => {
            this.timer = setTimeout(() => {
              this.showAllShopList(null, 1);
              this.pageNumAll = 1;
            }, 500);
          },
        );
      })
      .catch(() => {
        setErrorMsg(formatMessage(activateText.activateCardPlsRetry));
        setLoadMsg({ status: false, word: '' });
      });
  },

  jumpToShopIndex(shopId) {
    const uniqueId = helper.getUrlParam('uniqueId') || helper.getUrlParam('type');
    const { getQueueInfo } = this.props;

    switch (uniqueId) {
      case 'PD':
        getQueueInfo(shopId).then((res = {}) => {
          const { data } = res;
          if (data.code === '200') {
            const { queueTip, orderSyn } = data.data || {};
            if (!queueTip) {
              location.href = `${config.queueInfoURL}?shopId=${shopId}&uniqueId=PD`;
            } else {
              location.href = `${config.queueDetailURL}?shopId=${shopId}&orderSyn=${orderSyn}&uniqueId=PD`;
            }
          } else if (data.code === 'NOT_LOGIN') {
            // location.href = `${config.queueInfoURL}?shopId=${shopId}&uniqueId=PD`;
            // 排队之前先登录
            const url = `${config.queueInfoURL}?shopId=${shopId}&uniqueId=PD`;
            pageHelper.navigateToLoginPage({
              shopId,
              returnUrl: encodeURIComponent(url),
            });
          }
        });
        break;
      case 'TS':
        location.href = `${config.dishMenu4DinnerURL}?shopId=${shopId}&type=TS&uniqueId=TS`;
        break;
      case 'WM':
        location.href = `${config.dishMenu4takeoutURL}?shopId=${shopId}&type=WM&uniqueId=WM`;
        break;
      case 'YD':
        location.href = `${config.bookingURL}?shopId=${shopId}&uniqueId=YD`;
        break;
      default:
        break;
    }
  },
  formatDistance(distance) {
    if (!distance) {
      return;
    }
    let apart = parseInt(distance, 10);
    if (apart === 10000000) {
      apart = '';
    } else if (apart >= 1000) {
      apart = `≤${parseFloat((apart / 1000).toFixed(1))}km`;
    } else {
      apart = `≤${apart}m`;
    }
    return apart;
  },
  showAllShopList(e, pageNum) {
    if (e) {
      e.preventDefault();
    }
    // 百度统计代码
    if (window._hmt) {
      window._hmt.push(['_trackEvent', '门店列表', '查看所有门店', pageNum]);
    }

    this.setState({ showAllShop: true });
    const { keyWord, chosenPosition, dinningRoomIndex } = this.state;
    const formatKeyWord = keyWord
      .replace(/\?/g, '%3F')
      .replace(/&/g, '%26')
      .replace(/=/g, '%3D')
      .replace(/#/g, '%23');
    const { getAllShopList, curPosition, yunChengSchoolFlag, getYCSAllShopList } = this.props;
    const listObjParam = { pageNum, keyWord: formatKeyWord, dinningRoomIndex };

    if (yunChengSchoolFlag) {
      getYCSAllShopList(listObjParam);
    } else {
      getAllShopList(chosenPosition, curPosition, { pageNum, keyWord: formatKeyWord }, data => {
        if (data.cList && data.cList.length === 20) {
          this.setState({ showLoad: true });
        }
      });
    }
  },
  showNearShopList(e, pageNum) {
    if (e) {
      e.preventDefault();
    }
    // 百度统计代码
    if (window._hmt) {
      window._hmt.push(['_trackEvent', '门店列表', '查看附近门店', pageNum]);
    }

    this.setState({ showAllShop: true });
    const { keyWord } = this.state;
    const formatKeyWord = keyWord
      .replace(/\?/g, '%3F')
      .replace(/&/g, '%26')
      .replace(/=/g, '%3D')
      .replace(/#/g, '%23');
    const { getNearShopList, curPosition } = this.props;

    getNearShopList(curPosition, { pageNum, keyWord: formatKeyWord });
  },
  handleSuggestVisible() {},
  selectComplete() {},
  handleUserInput(keyWord) {
    const { selectType } = this.state;
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.setState({ keyWord }, () => {
      this.timer = setTimeout(() => {
        // this.props.setLoadMsg({ status: true, word: '正在切换关键词' });
        if (selectType === 'all') {
          this.props.clearAllShopList();
          this.showAllShopList(null, 1);
          this.pageNumAll = 1;
        } else if (selectType === 'near') {
          this.props.clearNearShopList();
          this.showNearShopList(null, 1);
          this.pageNumNear = 1;
        }
      }, 500);
    });
  },
  handleUserInputBlur() {
    const inputDoms = [].slice.call(document.querySelectorAll('input'));
    inputDoms.forEach((item, index) => {
      item.blur();
    });
  },
  renderShopList() {
    const { city, showCityChangeList, forceCityPopupVisible } = this.state;
    const { cityList } = this.props;
    const currentCity = { name: city ? `${city}` : '北京市' };
    const suggestVisible = false;
    const suggestList = [];

    return (
      <StandardAddrselectSearchbox
        forceCityPopupVisible={forceCityPopupVisible}
        onCurrentCityChange={this.cityChange}
        currentCity={currentCity}
        onUserInput={keyWord => {
          this.handleUserInput(keyWord, 'all');
        }}
        showCityChangeList={showCityChangeList}
        onShowCityChangeList={this.handleShowCityChangeList}
        notFindCityButton={'notFindCityButton'}
        triggerCityChange={this.triggerCityChange}
        placeholder={formatMessage(shopText.shopinputShopToSearch)}
        // 此处需要屏蔽
        suggestVisible={suggestVisible}
        suggest={suggestList}
        onSelectComplete={this.selectComplete}
        onSetSuggestVisible={this.handleSuggestVisible}
        cityList={cityList || []}
        hasNearChosen
        hasInputIcon={false}
        onSetCityPopupVisible={this.handleCityPopupVisible}
      />
    );
  },
  renderYcsShopList() {
    const { cityList, yunChengSchoolFlag } = this.props;
    const { dinningName, showCityChangeList } = this.state;
    const currentCity = { name: dinningName ? this.state.dinningName : '一食堂' };
    const suggestVisible = false;
    const suggestList = [];

    return (
      <StandardAddrselectSearchboxYCS
        onCurrentCityChange={this.cityChange}
        currentCity={currentCity}
        onUserInput={keyWord => {
          this.handleUserInput(keyWord, 'all');
        }}
        showCityChangeList={showCityChangeList}
        onShowCityChangeList={this.handleShowCityChangeList}
        notFindCityButton={'notFindCityButton'}
        triggerCityChange={this.triggerCityChange}
        placeholder={formatMessage(shopText.shopinputStoreToSearch)}
        suggestVisible={suggestVisible}
        suggest={suggestList}
        onSelectComplete={this.selectComplete}
        onSetSuggestVisible={this.handleSuggestVisible}
        cityList={cityList || []}
        yunChengSchoolFlag={yunChengSchoolFlag}
        hasNearChosen
        dinningChange={this.dinningChange}
      />
    );
  },
  render() {
    const { showLoad, selectType, ycsSelectType } = this.state;
    const { yunChengSchoolFlag } = this.props;

    let shopListEleme = '';
    let nearShopListElem = '';
    let allShopListElem = '';

    if (yunChengSchoolFlag) {
      shopListEleme = this.renderYcsShopList();
      nearShopListElem = selectType === 'near' && !ycsSelectType && this.getYCSNearShopList();
      allShopListElem = selectType === 'all' && ycsSelectType && this.getYCSAllShopList();
    } else {
      shopListEleme = this.renderShopList();
      nearShopListElem = selectType === 'near' && this.getNearShopList();
      allShopListElem = selectType === 'all' && this.getAllShopList();
    }

    return (
      <div className="o-flex__fluid o-flex o-flex--column shop-all-ts--search">
        {shopListEleme}
        <div className="o-flex__fluid" style={{ position: 'relative' }} onTouchStart={this.handleUserInputBlur}>
          <div className="shop-all-ts">
            <div>
              {/* {selectType === 'near' && this.getNearShopList()} */}
              {/* {selectType === 'all' && this.getAllShopList()} */}
              {nearShopListElem}
              {allShopListElem}
              {showLoad && selectType === 'all' && (
                <div className="loading">
                  <FormattedMessage {...shopText.shopscrollToLoad} />
                </div>
              )}
            </div>
          </div>
          <div className="copyrightbt">
            <FormattedMessage {...shopText.shopkrySupport} />
          </div>
        </div>
      </div>
    );
  },
});

module.exports = ShopAllTS;



// WEBPACK FOOTER //
// ./src/component/shop-list/shop-all-ts.jsx